<template>
  <li :class="classList">
    <span class="st-table-item__header">{{ itemHeader.name }}</span>
    <button
      v-if="clickable"
      @click="handleItemClick($event)"
      :class="clickableClassList"
      type="button"
      tabindex="0"
    >
      <span class="st-table-item__clickable__icon">
        <component :is="icon" :size="'md'" :name="iconName" useSvg inline />
      </span>
    </button>
    <span
      v-else
      class="st-table-item__value"
      :class="itemHeader.currentState ? stateMap.class : ''"
    >
      {{ value }}
    </span>
    <span
      class="st-table-item__secondary-value"
      :class="
        itemHeader.currentState ? 'st-table-item__secondary-value--padded' : ''
      "
      v-if="secondaryValue"
    >
      {{ secondaryValue }}
    </span>
  </li>
</template>

<script>
import StIcon from "../icon/Icon.vue";
import StIconLegacy from "../icon/IconLegacy.vue";
import { version } from "vue";

export default {
  name: "st-table-item",
  components: {
    StIcon,
    StIconLegacy,
  },
  props: {
    value: String,
    secondaryValue: String,
    itemHeader: Object,
    clickable: Boolean,
    iconName: String,
    disabled: Boolean,
  },
  computed: {
    classList() {
      return ["st-table-item"];
    },
    clickableClassList() {
      return [
        "st-table-item__clickable",
        this.disabled && "st-table-item__clickable__disabled",
      ];
    },
    stateMap() {
      const baseClass = "st-table-item__state";
      const map = {
        valid: {
          type: "valid",
          class: `${baseClass} st-table-item__state--green`,
        },
        invalid: {
          type: "invalid",
          class: `${baseClass} st-table-item__state--red`,
        },
        neutral: {
          type: "neural",
          class: `${baseClass} st-table-item__state--white`,
        },
      };
      if (map[this.itemHeader.currentState] === undefined) {
        console.error(
          "Skånetrafiken Shared Library ERROR: Prop currentState value did not match the following acceptable values: neutral, valid, invalid."
        );
      }
      return map[this.itemHeader.currentState];
    },
    icon() {
      return version && parseInt(version) === 3 ? "StIcon" : "StIconLegacy";
    },
  },
  methods: {
    handleItemClick(e) {
      this.$emit("onItemClick");
      e.stopPropagation();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../scss/main.scss";
.st-table-item {
  margin: 0;
  padding: rem-calc(12) 0;
  display: flex;
  flex: 1;
  font-size: rem-calc(14);
  color: $dark-grey;
  &:not(:last-child) {
    border-bottom: rem-calc(0.5) solid $light-grey;
    @include large {
      border-bottom: none;
    }
  }
  @include large {
    padding: rem-calc(20);
    font-size: rem-calc(16);
    flex-direction: column;
    border-bottom: none;
  }
  &__header {
    @include large {
      display: none;
    }
  }
  &__clickable {
    background: none;
    padding: 0;
    border: none;
    margin-left: auto;
    display: flex;
    font-weight: $semi-bold;
    color: $nästan-svart;
    font-family: inherit;
    cursor: pointer;
    @include large {
      margin-right: auto;
      margin-left: 0;
    }
    &__icon {
      margin-left: rem-calc(2);
    }

    &__disabled {
      cursor: default;
      opacity: 0.3;
    }
  }
  &__value {
    margin-left: auto;
    font-weight: $semi-bold;
    display: flex;
    align-items: center;
    word-break: break-word;

    @include large {
      margin-left: initial;
    }
  }
  &__state {
    &::before {
      content: "";
      display: flex;
      width: rem-calc(10);
      height: rem-calc(10);
      margin-right: rem-calc(5);
      -moz-border-radius: rem-calc(10);
      -webkit-border-radius: rem-calc(10);
      border-radius: rem-calc(10);
    }
    &--green {
      &::before {
        background: $groda;
      }
    }
    &--red {
      &::before {
        background: $hjarta;
      }
    }
    &--white {
      &::before {
        background: $vit;
        border: rem-calc(1) solid $varm-grå;
      }
    }
  }
  &__secondary-value {
    display: none;
    font-weight: $regular;
    font-size: rem-calc(14);
    &--padded {
      padding-left: rem-calc(15);
    }
    @include large {
      display: flex;
    }
  }
}
</style>
